export default "__VITE_ASSET__D4XkUqP2__"